export default __webpack_public_path__ + "static/media/09exigo.b349fa98.jpg";